<div class="db-counter" [ngClass]="{'db-counter-pricing': !!aiPricingCount, 'db-from-pricing': percentOfferPricing}">
<div [ngClass]="{'db-pricing': !!aiPricingCount}">
  <div class="timer">
    <p>{{countDown[0]}}</p>
    <p>{{countDown[1]}}</p>
  </div>
  <span class="time-unit">Days</span>
</div>
<span class="double-dot">
:
</span>
<div>
  <div class="timer">
    <p>{{countDown[2]}}</p>
    <p>{{countDown[3]}}</p>
  </div>
  <span class="time-unit">Hours</span>
</div>
<span class="double-dot">
:
</span>
<div>
  <div class="timer">
    <p>{{countDown[4]}}</p>
    <p>{{countDown[5]}}</p>
  </div>
  <span class="time-unit">Minutes</span>
</div>
</div>
